<web-design-system-modal [headline]="'savings-plan.savings-plan-strategy-revoke-modal.headline' | transloco" [dismissable]="false">
  <p>{{ 'savings-plan.savings-plan-strategy-revoke-modal.text' + (type ? '-' + type : '') | transloco }}</p>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <web-design-system-button size="small" (click)="activeModal.close()">
        {{ 'savings-plan.savings-plan-strategy-revoke-modal.btn' | transloco }}
      </web-design-system-button>
    </div>
  </div>
</web-design-system-modal>
